import httpClient from '~/http';
import { PrinterItem } from '../../types';

export const fetchPrinters = () => {
  return httpClient.get<{ printers: PrinterItem[] | null }>('/api/v2/printers');
};
